module.exports = __webpack_public_path__ + "img/croatia.d9f6602.webp";